'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = init;
function init(_ref) {
  var el = _ref.el,
      context = _ref.context;

  var videoButton = context.getElement('.' + context.className + '_Play');
  var videoPreview = context.getElement('.' + context.className + '_Preview');
  var videoPanel = context.getElement('.' + context.className + '_Video');
  var activeClass = 'sec-Video_Preview-active';

  videoButton.addEventListener('click', function (e) {
    videoPreview.classList.add(activeClass);

    videoPanel.play();
  });
}